import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import CancelIcon from "@mui/icons-material/Cancel";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import FileOpenIcon from "@mui/icons-material/FileOpen";

export const personColumns = (handleUpdate, handleDelete, handleDocument) => [
  {
    field: "dayoffTypeName",
    headerName: "İzin Türü",
    sortable: false,
    filterable: false,
    flex: 1,
    // editable: true,
  },
  {
    field: "start_Date",
    headerName: "İzin Başlangıç Tarihi",
    sortable: false,
    filterable: false,
    flex: 1,
    valueGetter: (value, row) =>
      row && moment(row.start_Date).format("DD/MM/YYYY"),
    // editable: true,
  },
  {
    field: "end_Date",
    headerName: "İzin Bitiş Tarihi",
    sortable: false,
    filterable: false,
    valueGetter: (value, row) =>
      row && moment(row.end_Date).format("DD/MM/YYYY"),
    flex: 1,
    // editable: true,
  },
  {
    field: "dayoff_Description",
    headerName: "İzin Hakkında",
    sortable: false,
    filterable: false,
    flex: 1,
    // description: "This column has a value getter and is not sortable.",
    // sortable: false,
    // width: 160,
    // valueGetter: (value, row) =>
    //   `${row.firstName || ""} ${row.lastName || ""}`,
  },
  {
    field: "isHalfDay",
    headerName: "Yarım/Tam Gün",
    flex: 1,
    sortable: false,
    filterable: false,
    valueGetter: (value, row) =>
      row && row.isHalfDay ? "Yarım Gün" : "Tam Gün",
    // description: "This column has a value getter and is not sortable.",
    // sortable: false,
    // width: 160,
    // valueGetter: (value, row) =>
    //   `${row.firstName || ""} ${row.lastName || ""}`,
  },
  {
    field: "isApprove",
    headerName: "Onay Durumu",
    flex: 1,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <div style={{ display: "flex", marginTop: 15 }}>
        {params.row.isApprove === null ? (
          <HourglassBottomIcon color="info" />
        ) : params.row.isApprove ? (
          <CheckCircleIcon color="success" />
        ) : (
          <CancelIcon color="error" />
        )}
      </div>
    ),
  },
  {
    field: "actions",
    headerName: "İşlemler",
    flex: 1,
    sortable: false,
    filterable: false,
    disableExport: true,
    renderCell: (params) => (
      <div style={{ display: "flex", gap: 8, marginTop: 5 }}>
        <IconButton
          variant="contained"
          color="secondary"
          disabled={params.row.isApprove !== null}
          onClick={() => handleUpdate(params.row.id)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          variant="contained"
          color="error"
          disabled={params.row.isApprove !== null}
          onClick={() => handleDelete(params.row.id)}
        >
          <DeleteIcon />
        </IconButton>
        <IconButton
          variant="contained"
          color="success"
          onClick={() => handleDocument(params.row.id)}
        >
          <FileOpenIcon />
        </IconButton>
      </div>
    ),
  },
];
